import React, { Dispatch, SetStateAction, useMemo } from 'react'

import { Button, Grid, Typography } from '@barracuda-internal/bds-core'

import { useFormatMessage } from 'lib/localization'
import { FormSpacer } from 'components/libs/layout/pages/pageLayout'
import styles from 'components/pages/inboundSettings/inboundSettingsStyles'
import IpAddressTable from 'components/libs/ipAddressTable/IpAddressTable'
import { useIsReadonly } from 'lib/hooks/useIsReadonly'
import { useBrblExemptLogic } from './useBrblExemptLogic'

const BASE_I18N_KEY = 'ess.inbound_settings.reputation'
const BASE_INBOUND_I18N_KEY = 'ess.inbound_settings'

export interface BrblExemptProps {
  delegateDirtyFormState: Dispatch<SetStateAction<boolean>>
}

const BrblExempt: React.FC<BrblExemptProps> = (props: BrblExemptProps) => {
  const isReadonly = useIsReadonly()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatInboundMessage = useFormatMessage(BASE_INBOUND_I18N_KEY)
  const inboundClasses = styles()
  const [state, eventHandlers] = useBrblExemptLogic()

  return useMemo(
    () => (
      <Grid container data-testid="brbl-exempt-section">
        <Typography variant="h4">{formatMessage('brbl_exemptions')}</Typography>
        <FormSpacer />
        <Button
          className={inboundClasses.bulkEdit}
          onClick={eventHandlers.onBulkEdit}
          variant="contained"
          size="small"
          data-testid="bulk-button-brbl"
          disabled={isReadonly}
        >
          {formatInboundMessage('bulk_edit')}
        </Button>
        <IpAddressTable
          data={state.tableData}
          onAddItem={eventHandlers.onAddItem}
          onRemoveItem={eventHandlers.onRemoveItem}
          data-testid="brbl-exempt-table"
          delegateDirtyFormState={props.delegateDirtyFormState}
        />
      </Grid>
    ),
    [
      formatMessage,
      formatInboundMessage,
      inboundClasses.bulkEdit,
      eventHandlers,
      state.tableData,
      isReadonly,
      props.delegateDirtyFormState
    ]
  )
}

export default BrblExempt
